import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import _compact from 'lodash/compact';
import _forEach from 'lodash/forEach';
import classes from './Dropdown.module.scss';

export class DropdownMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styles: {}
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateMenuLocation);
    this.updateMenuLocation();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateMenuLocation);
  }

  isElementChildOfButton(element) {
    const allChildren = this.props.buttonRef.getElementsByTagName('*');
    let isChild = false;
    _forEach(allChildren, (child) => {
      if (element === child) {
        isChild = true;
      }
    });
    return isChild;
  }

  handleClickOutside(evt) {
    if (!this.isElementChildOfButton(evt.target)) {
      this.props.handleCloseMenu(true);
    }
  }

  updateMenuLocation = () => {
    const { menuNoLeft, menuNoTop } = this.props;

    if (!menuNoLeft || !menuNoTop) {
      const styles = {};

      if (!menuNoLeft) {
        const leftOrientation =
          (this.props.buttonRef.offsetLeft +
            (this.props.buttonRef.offsetWidth / 2)) -
          (this.menu.offsetWidth - 9 - 7);

        styles.left = leftOrientation;
      }
      if (!menuNoTop) {
        const topOrientation = this.props.buttonRef.offsetHeight +
          this.props.buttonRef.offsetTop +
          10;

        styles.top = topOrientation;
      }
      this.setState({ styles });
    }
  };

  render() {
    const classNames = _compact([
      classes.dropdownMenu,
      this.props.isVisible ? classes.expanded : null,
      this.props.noCaret ? classes.noCaret : null,
      this.props.dropdownClassName
    ]).join(' ');

    return (
      <div
        onClick={this.props.handleCloseMenu}
        className={classNames}
        ref={(elt) => { this.menu = elt; }}
        style={this.state.styles}
      >
        {this.props.menuComponent}
      </div>
    );
  };
}

DropdownMenu.propTypes = {
  buttonRef: PT.object,
  dropdownClassName: PT.string,
  handleCloseMenu: PT.func.isRequired,
  isVisible: PT.bool.isRequired,
  menuComponent: PT.element.isRequired,
  menuNoLeft: PT.bool,
  menuNoTop: PT.bool,
  noCaret: PT.bool
};

export default onClickOutside(DropdownMenu);
